import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  baseUrl = environment.API_HOST;
  context: string;

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.context =
          this.context ?? this.route.snapshot.queryParams['context'];
        // neverending context: '7c7d351f-0967-46ef-8152-a0e2ed674bd3'

        sessionStorage.clear();
      }
    });
  }
}
